import React from 'react'
import './Select.css'
export function Select({list,placeholder,disabled,selectClass=""}) {
  return (
    <select  className={disabled?`select-input-disabled ${selectClass}`:`select-input ${selectClass}`} disabled={disabled}>
        <option>{placeholder}</option>
        {list.map(item=><option value={item.value}>{item.label}</option>)}
    </select>
  )
}
